import { Card, FlexContent } from "@rothoblaas/design-system";
import { FC } from "react";
import { Link } from "react-router-dom";
import { getAllowedAdminMenuEntries } from "../../components/adminMenuEntries";
import Header from "../../components/ui/Header";
import Icon from "../../components/ui/Icon";
import { useAuthContext } from "../../context/authContext";
import useI18n from "../../hooks/useTranslations";
import styles from "./AdminDashboard.module.css";

const AdminDashboard: FC = () => {
  const i18n = useI18n();
  const auth = useAuthContext();

  return (
    <>
      <Header title={i18n.translation.common.administration} />

      <FlexContent padding noPaddingTop>
        <div className={styles.grid}>
          {getAllowedAdminMenuEntries(auth.permissions).map((entry) => (
            <Link key={entry.path} to={entry.path} className={styles.link}>
              <Card shadow className={styles.card}>
                <div className={styles.cardHeader}>
                  <Icon glyph={entry.icon} className={styles.icon} />
                  <Card.Title>{entry.getTitle(i18n.translation)}</Card.Title>
                </div>
                <p className={styles.description}>{entry.getDescription(i18n.translation)}</p>
              </Card>
            </Link>
          ))}
        </div>
      </FlexContent>
    </>
  );
};

export default AdminDashboard;
